import React from "react";

import {
  Select,
  MenuItem,
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";

export interface FormFieldDropdownProps {
  name: string;
  label: string;
  control: any;
  options: { value: string; label: string; iconUrl?: string }[];
  rules?: any;
  helperText?: string;
  onBlur?: () => void;
  disabled?: boolean;
}

export const FormFieldDropdown = ({
  name,
  label,
  control,
  options,
  rules,
  disabled,
  helperText,
  ...props
}: FormFieldDropdownProps) => {
  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <Select {...field} label={label} disabled={disabled} {...props} error={!!error}>
            {error && <FormHelperText>{error.message}</FormHelperText>}
            {options.map(({ value, label, iconUrl }) => (
              <MenuItem
                key={value}
                value={value}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {iconUrl && (
                    <img
                      loading="lazy"
                      width="20"
                      src={iconUrl}
                      srcSet={iconUrl}
                      alt=""
                    />
                  )}
                  <Typography sx={{ pl: 1 }}>{label}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        )}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
